class SortForm extends HTMLElement {
    constructor() {
        super()
    }

    async connectedCallback() {
        const sectionId = this.getAttribute("data-section-id")
        const form = this.querySelector("form")

        if (!sectionId || !form) {
            return
        }

        form.addEventListener("input", async e => {
            e.preventDefault()

            const searchParams = [
                document.querySelector("uwp-filter-form form"),
                e.target instanceof HTMLElement ? e.target.closest("form") : null
            ]
                .filter(Boolean)
                .map(f => {
                    // @ts-expect-error - TS doesn't know that filter(Boolean) removes nulls
                    const formData = new URLSearchParams(new FormData(f)).toString()

                    if (formData.includes("q=")) {
                        return formData.replace(/&sort_by=[^&]+/, "")
                    }

                    return formData
                })
                .filter(Boolean)
                .join("&")

            try {
                const sections = await fetch(
                    `${window.location.pathname}?sections=${sectionId}&${searchParams}`
                ).then(r => r.json())

                document.dispatchEvent(
                    new CustomEvent("products:update", { detail: { sections } })
                )

                history.pushState(
                    { searchParams },
                    "",
                    `${window.location.pathname}${searchParams.includes("?") || !searchParams
                        ? searchParams
                        : "?".concat(searchParams)
                    }`
                )
            } catch (error) {
                console.error("Failed to update products:", error)
            } finally {
                this.toggleAttribute("data-loading", false)
            }
        })
    }

    disconnectedCallback() {
        if (this.unsubscribe) {
            this.unsubscribe()
        }
    }
}

customElements.define("uwp-sort-form", SortForm)
